// extracted by mini-css-extract-plugin
module.exports = {"modal_header":"styles_modal_header__36vk2","modal_body":"styles_modal_body__2Bobx","modal_footer":"styles_modal_footer__ceU49"};